import React, { Component, Fragment } from 'react';
import Wrapper from './../../../common/component/Wrapper';
import * as Func from '../../../../../helpers/functions';
import { Link } from 'react-router-dom';
import { PATHS, ORDER } from '../../../../../constants/Define';
import { FormWrapperItem, ListComponent, StatusComponent, FilterDropdown } from '../../../common/component/Index';
import FontIcon, { SolidIcons } from '../../../common/component/FontIcon';
import Dropdown from '../../../common/component/Dropdown';

import { TicketAssignConfig } from '../../../../../models/Ticket';
import { Icon, Tooltip, Menu, Popover } from 'antd';
import { find, toArray } from 'lodash';
import './TicketAssignConfigList.less';
import Span from '../../../common/component/Span';
import { getLocaleFullName } from '../../../../../utils/commonUtils';
import Modal from '../../../common/component/Modal';
import moment from 'moment';

const defaultState = {

};

const ListCols = [
    'user', 'orderItemType', 'workSession',
    'assignedDays',
    'status',
];
const ModelFields = Object.getOwnPropertyNames(new TicketAssignConfig());

export default class TicketAssignConfigList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                user: {
                    render: (text, record) => {
                        if (!record.userDetail) return null
                        const name = getLocaleFullName(record.userDetail.firstname, record.userDetail.lastname);
                        return <Popover
                            title={this.props.t(`item.ticket.contactInfo`)}
                            content={
                                <Wrapper style={{ display: 'flex', flexDirection: 'column' }}>
                                    {!!record.userDetail.email && <Span className="w100-percent">{this.props.t(`item.ticket.contactEmail`)}: {record.userDetail.email}</Span>}
                                    {!!record.userDetail.phoneNumber && <Span className="w100-percent">{this.props.t(`item.ticket.contactPhone`)}: {record.userDetail.phoneNumber}</Span>}
                                </Wrapper>
                            }>
                            <Span className="w100-percent">{this.props.t(`item.ticket.contactName`)}: {name}</Span>
                        </Popover>
                    },
                    // key: 'userId',
                    // filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    //     <FilterDropdown
                    //         setSelectedKeys={setSelectedKeys}
                    //         selectedKeys={selectedKeys}
                    //         confirm={confirm}
                    //         clearFilters={clearFilters}
                    //     >
                    //     </FilterDropdown>
                    // ),
                    // filterIcon: filtered => (
                    //     <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    // ),
                },
                orderItemType: {
                    key: 'orderItemType',
                    render: (text, record) => {
                        const typeEnum = find(toArray(ORDER.TYPES), item => item.id === record.orderItemType)
                        return !!typeEnum && <Tooltip key={typeEnum.key} title={this.props.t(`item.order.orderTypes.${typeEnum.key}`)}><Span className="ml-2">
                            <FontIcon key={typeEnum.key} color={typeEnum.color} icon={SolidIcons[typeEnum.icon]} size="lg" />
                        </Span></Tooltip>
                    },
                    filters: Object.keys(ORDER.TYPES).map(k => ({ value: ORDER.TYPES[k].id, text: this.props.t(`item.order.orderTypes.${k.toLowerCase()}`) })),
                    filterMultiple: false,
                },
                workSession: {
                    key: 'workSession',
                    render: (text, record) => record.workSessionFrom ? `${record.workSessionFrom} - ${record.workSessionTo}` : '',
                },
                assignedDays: {
                    width: 55 * 7,
                    align: 'center',
                    render: (text, record) => (
                        <Wrapper className="ant-btn-group assignedDays">
                            {moment.localeData('en').weekdays().map(day => {
                                const dayKey = day.toLowerCase();
                                return <Span key={dayKey} className={`ant-btn ant-btn-${record[dayKey] ? 'primary' : 'disabled'}`}>{this.props.t(`item.ticket.${dayKey}`)}</Span>
                            })}
                        </Wrapper>
                    )
                },
                status: {
                    key: 'isDisabled',
                    render: (isDisabled, record) => <StatusComponent color={!record.isDisabled ? 'green' : 'red'}
                        label={record.isDisabled ? this.props.t('item.ticket.isDisabled') : this.props.t('item.ticket.isEnabled')} />,
                },
                action: {
                    width: 100,
                    align: 'center',
                    key: 'action',
                    fixed: 'right',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
        };
    }

    render() {
        const { t, ticketAssignConfigs, loading, pagination } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <Wrapper className="mt-2 ticket-assign-config-list">
                <ListComponent
                    // scroll={{ x: 1800 }}
                    classParent="m-0 p-0 col-md-12" classChildren="p-0"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => record.id ? record.id : k}
                    dataSource={Func.getDataSource(ticketAssignConfigs || [], modelItem)}
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'ticket'
                    })}
                    pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, current: pagination.pageIndex, pageSize: pagination.pageSize }}
                    onChange={this.props.onChange}
                    componentTableList={{}}
                />
            </Wrapper>
        );
    }

    renderEditComponent(item) {
        const { t, permissions } = this.props;
        return (
            <Dropdown overlay={
                <Menu className="action-menu">
                    {
                        permissions && permissions.allowUpdate &&
                        <Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.TICKET_ASSIGN_CONFIG.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                            </Link>
                        </Menu.Item>
                    }

                    {
                        permissions && permissions.allowDelete &&
                        <Menu.Item onClick={e => this.onRemove(item)}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                    }
                </Menu>
            }>
                <Icon type="more" className="fs20 cursorPointer" />
            </Dropdown>
        )
    }

    onRemove = (item) => {
        const { t } = this.props;
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.ticket.ticketAssignConfigs`)),
            content: item.userDetail && getLocaleFullName(item.userDetail.firstname, item.userDetail.lastname),
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: () => {
                this.props.onDelete && this.props.onDelete(item)
            },
        });
    }

}

TicketAssignConfigList.defaultProps = {
    ticketAssignConfigs: [],
    pagination: {},
    permissions: {},
    loading: false,
    onChange: (pagination, filters, sorter) => { },
}

